import { FC, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { MainLayout } from 'views/layouts'
import TitleDiv from 'views/components/UI/TitleDiv'
import QuestionaryForm from 'views/components/Forms/cuestionary'
import { useNotification } from 'lib/context/notification.context'
import { superAdminRoutes } from 'router/routes'

const NewQuestionary: FC = () => {
  const navigate = useNavigate()
  const { getWarning } = useNotification()
  const role = useSelector((state: any) => state.auth.role)
  const hasQuestionnaireManagement = useSelector((state: any) => state.user.hasQuestionnaireManagement)
  const canManageQuestionnaires =
    role !== 'platform_admin' &&
    (role === 'super_admin' || hasQuestionnaireManagement)

  useEffect(() => {
    if (!canManageQuestionnaires) {
      getWarning('Comunícate con el administrador.')
      navigate(superAdminRoutes.Cuestionario)
    }
  }, [canManageQuestionnaires, getWarning, navigate])

  if (!canManageQuestionnaires) return null

  return (
    <MainLayout>
      <TitleDiv>
        <h2 style={{ fontSize: 32 }}>Nuevo cuestionario</h2>
      </TitleDiv>
      <QuestionaryForm />
    </MainLayout>
  )
}

export default NewQuestionary
